type SCREEN_SIZES =
  | 'MAX'
  | 'LARGE_2X'
  | 'LARGE_1X'
  | 'LARGE_1X_S'
  | 'WIDE_DESKTOP'
  | 'DESKTOP'
  | 'TABLET'
  | 'PHONE'
  | 'SMALL';
export type BreakPoint = {
  [point in SCREEN_SIZES]: `${number}px`;
};

export const breakPoint: BreakPoint = {
  MAX: '9999px',
  LARGE_2X: '1600px',
  LARGE_1X: '1200px',
  LARGE_1X_S: '1199px',
  WIDE_DESKTOP: '992px',
  DESKTOP: '768px',
  TABLET: '576px',
  PHONE: '480px',
  SMALL: '400px',
};

export const LANDING_BREAKPOINT_VALUE = 1200;
export const LANDING_BREAKPOINT = `${LANDING_BREAKPOINT_VALUE}px`;

export const mediaQueries = {
  LANDING_UP: `@media only screen and (min-width: ${LANDING_BREAKPOINT})`,
  LARGE_1X_UP: `@media only screen and (min-width: 1200px)`,
  DESKTOP: `@media only screen and (max-width: ${breakPoint.DESKTOP})`,
  TABLET: `@media only screen and (max-width: ${breakPoint.TABLET})`,
  SMALL: `@media only screen and (max-width: ${breakPoint.SMALL})`,
  PHONE: `@media only screen and (max-width: ${breakPoint.PHONE})`,
  GALLERY_SMALL_SCREEN: `@media only screen and (max-width: 1047px)`,
};

export type MediaQueriesType = typeof mediaQueries;

/**
 * antd responsive sizes
 * https://github.com/ant-design/ant-design/blob/master/components/_util/responsiveObserve.ts
 */
export type BreakpointTypes = 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs';
export type IBreakpointMap = Record<BreakpointTypes, string>;
export const responsiveMap: IBreakpointMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)',
};

export default breakPoint;
